export default "__VITE_ASSET__4be529c4__"